import React from "react";
import { Stack, Typography, Switch } from "../ui";

const SnpSwitch = ({
    leftLabel = "",
    rightLabel = "",
    checked = false,
    onChange = () => { },
    color = "primary",
    spacing = 2,
    direction = "row",
    labelStyles = {},
    switchProps = {},
    stackProps = {},
}) => {
    return (
        <Stack direction={direction} spacing={spacing} alignItems="center" {...stackProps}>
            {leftLabel && (
                <Typography
                    sx={{
                        fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                        fontWeight: 400,
                        whiteSpace: "pre-wrap",
                        overflowWrap: "break-word",
                        ...labelStyles,
                    }}
                >
                    {leftLabel}
                </Typography>
            )}

            <Switch
                color={color}
                checked={checked}
                onChange={onChange}
                {...switchProps}
            />

            {rightLabel && (
                <Typography
                    sx={{
                        fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                        fontWeight: 400,
                        whiteSpace: "pre-wrap",
                        overflowWrap: "break-word",
                        ...labelStyles,
                    }}
                >
                    {rightLabel}
                </Typography>
            )}
        </Stack>
    );
};

export default SnpSwitch;
